import React from 'react'
import {
    UiCol,
    UiSingleRow,
} from "../../_uiComponents/grid-container/GridContainer";


export default function CookiePolicyModal(props) {

 
    return (
        <>

            <UiSingleRow className="sb-modal-content-wr">
                <UiCol lg="6">

                    <h5>01.Introduction</h5>

                    <p> Sherbet Rewards & Motivation Technologies Limited (“Sherbet”, “we, “our”) uses cookies on its website. This Cookie Notice explains more about cookies and why we use them. It also explains how you can control and opt out of receiving them.</p>

                    <p>This policy should be read together with our Privacy Notice which sets out how and why we collect, store, use and share personal information generally, as well as your rights in relation to your personal information and details of how to contact us and supervisory authorities if you have a complaint.
                        We update this Cookie Notice from time to time in response to changes in applicable laws and regulations, changes to our processing practices and to products and services we offer. When changes are made, we will update the last updated date of this notice. Please review this Cookie Notice periodically to check for updates.</p>

                    <h5>02.About Cookies</h5>

                    <p>A cookie is a small text file which may be downloaded to your device when you visit our website. We use cookies to allow our website to function correctly, remember your preferences and to track visitors to our website.
                        The cookies we use on our website fall into the following categories:</p>

                    <h5>Statistics or Analytics Cookies</h5>

                    <p>We use cookies to collect information about the use of our website by visitors such as the pages they visit most often, how they arrived at our website and associated information. These do not collect any directly identifiable personal information about visitors.  We use these cookies to learn more about how our website is used to identify problems and areas for improvement.</p>

                    <h5> Functionality Cookies</h5>

                    <p>Functionality cookies remember the choices you make when you visit our website. This includes, for example, your consent to the use of cookies on our website.</p>

                    <h5> Marketing or Targeting Cookies</h5>

                    <p>These are cookies placed by third parties on our website which record your visit to our website, the pages you have visited and the links you have followed. They use this information for advertising purposes.</p>

                    <h5>Learn More About Cookies</h5>

                    <p>For further information on cookies generally, including how to control and manage them, please visit www.aboutcookies.org or www.allaboutcookies.org.</p>
                </UiCol>
                <UiCol lg="6">

                    <h5>  03.Cookie Sharing with Third Parties</h5>

                    <p>Please note that we do not share the information collected by the cookies we set with any third party.</p>

                    <p>Google may share the information collected by the Double click cookies with third parties for the purposes of targeted advertising. Please visit their privacy policies for more information, using the links set out in the table above.</p>

                    <h5>04.Changing Your Cookies Preferences</h5>

                    <p>You can allow or block cookies by activating the setting on your browser that permits you to change the setting of all or some cookies. Please note that disabling cookies may affect the availability or functionality of our website. Most of the website will function normally, however, functions that rely on cookies such as Insert example (e.g. the use of our online enquiry form), will be disabled.</p>

                    <p>If you would like more information on how to manage cookies on some popular browsers, please click on the links below.</p>

                    <ul>
                        <li>Internet Explorer</li>
                        <li> Google Chrome</li>
                        <li>Apple Safari</li>
                        <li>Microsoft Edge</li>
                        <li>Mozilla Firefox</li>
                    </ul>

                    <h5>05.Contact Us</h5>

                    <p>Should you wish to contact us, you can do so in several ways;</p>
                    <ul>
                        <li> Sending an email to mydata@sherbetrewards.com</li>
                        <li>Phone us at 0207 605 4500</li>
                        <li>Write to us at: Strata, Featherbed Court, Mixbury, Brackley, NN13 5RN</li>
                    </ul>

                    <p>We may need to confirm your identity in which case we will ask you for two of the following forms of identity:</p>
                    <ul>
                        <li>Driving license</li>
                        <li>Passport</li>
                        <li> Birth certificate</li>
                        <li>Utility bill not older than three months.</li>
                    </ul>

                    <p>A minimum of one piece of photographic ID listed above and a supporting document is required.</p>

                    <p>Should any subject access requests submitted be manifestly unfounded or excessive, then we may (in line with GDPR) either; charge a reasonable fee (taking into account the administrative costs of providing the information) or refuse to respond. Where a decision is taken to refuse to respond to a request, the data subject will be provided with an explanation for the decision along with details of their rights to complain to the supervisory authority and to a judicial remedy. This will be provided without undue delay and at latest within one month from receipt of the request.</p>

                    <h5>06.Changes to this Policy</h5>

                    <p>This policy was last updated in April 2024.</p>

                </UiCol>
            </UiSingleRow>


        </>
    )
}
